/* eslint-disable import/no-named-as-default-member */
import common from './storeTypeConstant';
import { appendModuleKeyPrefix } from './util';
export const STORE_ROOT_NAME = 'sr';
export default {
  STORE_ROOT_NAME,
  [common.NAME]: appendModuleKeyPrefix(common, STORE_ROOT_NAME)
};